<template>
    <!-- 生活消费  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'life',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--47.png",
        }
    },
    computed: {
        title() {
            return this.$t('life.title');
        },
        subtitle() {
            return this.$t('life.subtitle');
        },
        description() {
            return this.$t('life.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    },
}
</script>
